import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ReportService } from '../../report.service';

@Component({
    selector: 'app-tokenized-cards-report',
    templateUrl: './tokenized-cards-report-modal.component.html',
    styles: [],
    standalone: false
})
export class TokenizedCardsReportComponent implements OnInit, OnDestroy{
  public form: UntypedFormGroup;
  public isLoading                           = 0;
  public minEndDate: Date                    = null;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private toast: ToastrService,
    private reportService: ReportService,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TokenizedCardsReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private buildForm(): void {
    this.form = this.fb.group({
      start_date: [null],
      end_date:   [null],
    });

    this.subscribeToDateChanges();
  }

  private subscribeToDateChanges(): void {
    const startDateControl = this.form.get('start_date');
    const endDateControl   = this.form.get('end_date');

    this.minEndDate = startDateControl.value;

    this.subscriptions.push(
      startDateControl.valueChanges.subscribe((startDate: Date | null) => {
        this.minEndDate = startDate;

        if (this.isDateBefore(startDate, endDateControl.value)) {
          endDateControl.patchValue(null);
        }
      }),
    );
  }

  private isDateBefore(startDate: Date | null, endDate: Date | null): boolean {
    if (!startDate || !endDate) {
      return false;
    }

    return new Date(endDate).getTime() < new Date(startDate).getTime();
  }

  public sendReportData(): void {
    if (!this.form.valid) {
      return;
    }
    const isoString = this.form.value.end_date?.toISOString() ?? '';
    const endOfDayISOStringV2 = DateTime.fromISO(isoString).endOf('day').toISO({ includeOffset: false }) ?? null;
    const requestData = {
      start_date: this.form.value.start_date?.toISOString() ?? null,
      end_date:   endOfDayISOStringV2,
    };
    this.isLoading++;
    this.subscriptions.push(
      this.reportService.generateTokenizedCardsReport(requestData).pipe(finalize(() => this.isLoading--))
        .subscribe(res => {
            this.dialogRef.close(true);
            this.toast.success(res.message);
          },
          (err) => console.error('Error while generating tokenized cards report', err),
        )
    );
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

}
